import { useAuth0 } from "@auth0/auth0-react";
import { matchPath } from "react-router-dom";
import { AUTH, ORGANIZATION } from "./constants";

export * as Admin from "./Admin";
export * as Login from "./Login";
export * as OrgAdmin from "./OrgAdmin";
export * as Parent from "./Parent";

export const AuthCallback = {
  path: `/${AUTH}`,
  orgPath: `/${ORGANIZATION}/${AUTH}`,
};

export const isAuthPath = (path: string): boolean => {
  const avelaAdminPath = matchPath(
    { path: AuthCallback.path, end: false, caseSensitive: false },
    path
  );
  const orgPath = matchPath(
    { path: AuthCallback.orgPath, end: false, caseSensitive: false },
    path
  );
  return avelaAdminPath !== null || orgPath !== null;
};

export const logoutPath = "/logout";
export const logout = (returnTo: string | undefined): string => {
  if (returnTo === undefined) {
    return logoutPath;
  }

  const searchParams = new URLSearchParams({ path: returnTo });
  return `${logoutPath}?${searchParams.toString()}`;
};

export const useLogout = (returnTo: string | undefined) => {
  const { isAuthenticated } = useAuth0();
  if (!isAuthenticated) {
    return `${returnTo}`;
  }

  return logout(returnTo);
};

export const NoOrgRedirectPage = {
  URL: "https://avela.org/apply-redirect",
};

export const verifyEmailPath = `/${ORGANIZATION}/verify-email`;
export const verifyEmail = (org: string) => {
  return `/${org}/verify-email`;
};

export const emailVerificationPath = `/${ORGANIZATION}/email-verification`;
export const emailVerification = emailVerificationPath;

export const redirectPath = "/redirect";
export const redirect = redirectPath;

export const pageRedirectPath = "/page-redirect";
export const pageRedirect = pageRedirectPath;

export const isParentPortalPath = (path: string): boolean => {
  const adminPath = matchPath(
    { path: "/admin", end: false, caseSensitive: false },
    path
  );
  const orgAdminPath = matchPath(
    { path: `/${ORGANIZATION}/admin`, end: false, caseSensitive: false },
    path
  );
  return adminPath === null && orgAdminPath === null;
};

export function parseRelativeUrl(path: string) {
  try {
    return new URL(path, window.location.origin);
  } catch (error) {
    return null;
  }
}

/**
 * Returns a same-origin path suitable for redirects, or null if the input is
 * unsafe (e.g. javascript:, data:, protocol-relative, or absolute external URLs).
 */
export function getSafeInternalRedirectPath(path: string): string | null {
  try {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return null;
    }
    // A same-origin URL can still have a path beginning with "//" (or "/\",
    // which browsers normalize to "//"). Returning only the pathname would
    // yield a protocol-relative string that re-resolves to an external origin
    // when handed to window.location.replace / navigate.
    if (url.pathname.startsWith("//")) {
      return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
